import { Row, Col } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const PositionMutateFormTemplate = () => {
  return (
    <Row>
      <Col xs={12}>
        <CrudPlaceholderInput name="position" />
      </Col>
    </Row>
  );
};
